import { ga } from 'js/analytics/adapters'
export const trackRegistrationMethod = ({ method }) => {
  ga.track('choose_registration_method', { registration_method: method })
}
